module.exports = __webpack_public_path__ + "static/sitnorebricasta-ab-konstr-47ac889ddca713415b0fbf807390d189.png";